import { Component } from '@angular/core';

@Component({
  selector: 'ngx-custom-auth-layout',
  templateUrl: './custom-auth-layout.component.html',
  styleUrls: ['./custom-auth-layout.component.scss']
})
export class CustomAuthLayoutComponent {

}
